module.exports = __webpack_public_path__ + "img/recaptcha.4aa12810.svg";